module.exports = __webpack_public_path__ + "img/xaas-occc.5d64ae1.png";